import React from 'react';
// import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
// import { portalActions } from "../../../store/portal-slice";
// import whitelabelConfig from "@whitelabel-config";
// import { useUiState } from "helpers/useUiState";
import { useApi } from "helpers/useApi";
// import api from "helpers/api";
export const useAuthSrv = () => {
    // const { isAppLoading } = useUiState();
    const { api } = useApi();
    const portalSessionMeta = useSelector((state: any) => state.portal.micrositeSession);
    const portalAuthSessionMeta = useSelector((state: any) => state.portal.authSession);
    const generate2faOTP = () => {
        if (portalSessionMeta.urlRef) {
            // let payload = JSON.stringify(portalSessionMeta.urlRef);
            let payload = {
                URN: portalSessionMeta.urlRef,
                AUTH_TYPE: 1
            }
            return api.post('/api/Authentication/', payload)
        }

    }
    const midAuthenticatOTP = () => {
        if (portalSessionMeta.urlRef) {
            let payload = {
                registrationCode: portalSessionMeta.urlRef,
                AUTH_TYPE: 1
            }
            return api.post('/api/Authentication/mid', payload)
        }

    }
    const generateEmailPhoneOTP = (loginId: string, uri: string) => {
        let payload = JSON.stringify(loginId);
        return api.post('/api/Authentication/' + uri, payload)

    }
    const generateAnonymousAuthToken = () => {
        if (portalSessionMeta.urlRef) {
            // let payload = JSON.stringify(portalSessionMeta.urlRef);
            let payload = {
                URN: portalSessionMeta.urlRef,
                AUTH_TYPE: 0
            }
            return api.post('/api/Authentication/', payload)
        }
    }
    const verifyOTP = (token: string, otp: string, AuthenticationMode: any = null, AuthenticationModeRef: any = null) => {
        if (portalSessionMeta.urlRef || portalAuthSessionMeta.user_id) {
            let payloadMicrosite = {
                ReferenceID: token,
                Token: otp,
            }
            let payloadMP = {
                AuthenticationMode: AuthenticationMode,
                TokenDetail: payloadMicrosite,
                UniqueReference: AuthenticationModeRef
            }
            let payload = (AuthenticationMode === null || AuthenticationMode === false) ? payloadMicrosite : payloadMP;
            return api.post(`/api/Authentication/${portalSessionMeta.urlRef ? portalSessionMeta.urlRef + '/' : ''}verify`, payload)
        }
    }
    const verifyMedicaidOTP = (token: string, otp: string, AuthenticationMode: any = null, AuthenticationModeRef: any = null) => {
        if (portalSessionMeta.urlRef || portalAuthSessionMeta.user_id) {
            let payloadMicrosite = {
                ReferenceID: token,
                Token: otp,
            }
            let payloadMP = {
                AuthenticationMode: AuthenticationMode,
                TokenDetail: payloadMicrosite,
                UniqueReference: AuthenticationModeRef
            }
            let payload = (AuthenticationMode === null || AuthenticationMode === false) ? payloadMicrosite : payloadMP;
            return api.post(`/api/Authentication/${portalSessionMeta.urlRef ? portalSessionMeta.urlRef + '/' : ''}medicaid/verify`, payload)
        }
    }
    const verifyPII = (piiDatas: any) => {
        let payload = {
            ...piiDatas,
            DateOfBirth: piiDatas.DateOfBirth,
            MemberID: piiDatas.MemberID ? piiDatas.MemberID : null,
            SurveyUniqueReference: piiDatas.SurveyUniqueReference ? piiDatas.SurveyUniqueReference : null
        }
        return api.post(`/api/authentication/seclvl`, payload)
        // }
    }
    const generateMemberName = () => {

        return api.get('/api/user/info')
    }
    return { generate2faOTP, verifyOTP, verifyPII, generateAnonymousAuthToken, generateEmailPhoneOTP,generateMemberName, midAuthenticatOTP, verifyMedicaidOTP }
}